import { Stack, Tooltip, Typography } from "@mui/material"
import { ReactElement } from "react"
import { NodeProps } from "reactflow"

type NodeContainerProps = NodeProps & {
  children: ReactElement
}

const NodeContainer = ({ children, ...props }: NodeContainerProps) => {
  const isNode = "display" in props.data
  const nodeOrGroup = isNode ? "Node" : "Group"

  let groupInGroups = ""
  if ("display" in props.data)
    groupInGroups = props.data.display?.groups
      ?.map((x: string) => props.data.labelMap[x])
      .join(" → ")
  else groupInGroups = props.data.labelMap[props.data.group.parent]

  const label = `${nodeOrGroup}: ${isNode ? props.data.display?.label : props.data.group?.label}`

  return (
    <Tooltip
      arrow
      followCursor
      componentsProps={{ tooltip: { sx: { maxWidth: "none" } } }}
      title={
        <Stack alignItems="center">
          {groupInGroups !== undefined && (
            <Typography sx={{ fontSize: 12 }}>Parent Group: {groupInGroups}</Typography>
          )}
          <Typography sx={{ fontWeight: "bold" }}>{label}</Typography>
        </Stack>
      }
    >
      {children}
    </Tooltip>
  )
}

export default NodeContainer
